import { fetcher } from "../../utils/fetcher.js";

export const updateBoard = (boardId, updateData) => {
  return fetcher.put(`/api/boards/${boardId}`, updateData);
};
